<script setup lang="ts">
import { type PropType } from "vue";
import type { UIColor } from "../../..";

defineProps({
  colorBackground: {
    type: String as PropType<UIColor>,
    required: true,
  },

  colorForeground: {
    type: String as PropType<UIColor>,
    required: true,
  },

  opacityBackground: {
    type: String,
    required: true,
  },

  opacityForeground: {
    type: String,
    required: true,
  },

  borderRadius: {
    type: String,
    default: undefined,
  },

  maskImageDisable: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    :class="['chrome-overlay', $style.container]"
    :style="{ '--overlay-border-radius': `var(${borderRadius})` }"
  >
    <div
      :class="['chrome-overlay-background', $style.background]"
      :style="{
        '--overlay-color-background': `var(${colorBackground})`,
        '--overlay-opacity-background': opacityBackground,
      }"
    />

    <div
      :class="[
        'chrome-overlay-foreground',
        $style.foreground,
        !maskImageDisable && $style.foregroundMaskImage,
      ]"
      :style="{
        '--overlay-color-foreground': `var(${colorForeground})`,
        '--overlay-opacity-foreground': opacityForeground,
      }"
    />
  </div>
</template>

<style module>
.container,
.background,
.foreground {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  cursor: inherit;
}

.container {
  border-radius: var(--overlay-border-radius);
  overflow: hidden;
}

.background {
  background-color: var(--overlay-color-background);
  opacity: var(--overlay-opacity-background);
}

.foregroundMaskImage {
  opacity: var(--overlay-opacity-foreground);
  background-color: var(--overlay-color-foreground);
  background-image: url("./assets/tile.svg");
  background-origin: top left;
  background-repeat: repeat;
}

.foreground {
  opacity: var(--overlay-opacity-foreground);
  background-color: var(--overlay-color-foreground);
}
</style>
